import React from "react";

import "./Agent.css";

const AgentContent = () => {
  return (
<>
  
     <section class="hero_single version_2 Services">
      <div class="wrapper">
        <div class="container">
		    <div class="Seychelles">
        <h3 style={{textTransform: 'inherit'}}>Have the ability to create your guests itinerary whilst they are still sitting in front of you!</h3>
        <h4 style={{color: '#ffbd07'}}>Accommodations, Attractions & Things to Do, Deals & Packages, Live aboard, Land & Ferry Transfers and Wedding Packages... All in one place!</h4>
        <p>Make proposal, build the trip and close the deal within minutes with instant live inventory.</p>
        {/* <p>Remove Explore the Travel Services which you can list with us Help when you need it (insert our <a href="https://www.tawk.to/">tawk.to</a> link) remove tip for success</p> */}
              <span className="buttons-agents"><a href="/agentsignup">Click here to create your agent account </a></span>
			</div>
          
        </div>
      </div>
    </section>
    
   
  <div className="bg_color_1">
      <div className="container">
        <div className="main_title_2">
          <h3>Benefits of working with us</h3><br/>
          <span><em></em></span>
        </div>
        <div className="row" style={{paddingTop: '15px'}}>
          <div className="col-lg-6">
            <div className="box_news">
              <figure>
              <i className="pe-7s-display1"></i>
              </figure>
              <h4>Best Rates </h4>
              <p>Exclusive rates for our agents </p>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="box_news">
              <figure>
              <i className="pe-7s-graph1"></i>
              </figure>
              <h4>Personalize Care</h4>
              <p>Personalized help whenever you have question</p>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="box_news">
              <figure>
              <i className="pe-7s-graph3"></i>
              </figure>
              <h4>Best Inventory </h4>
              <p>Best inventories in and around Seychelles</p>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="box_news">
              <figure>
              <i className="pe-7s-unlock"></i>
              </figure>
              <h4>Confidentiality Assured</h4>
              <p>Complete confidentiality of your customer details & bookings </p>
            </div>
          </div>
          
        </div>
      </div>
    
    </div>

    <div id="advantage" class="PartnerAdvantagestyles__PartnerAdvantageMainWrap-sc-4j37pk-0 gtdmCg">
    <div class="PartnerAdvantagestyles__PartnerAdvantageInnerWrap-sc-4j37pk-1 jtwPYZ">
    <div class="PartnerAdvantagestyles__WhyPartnerHeadWrap-sc-4j37pk-2 dunmzM">
    {/* <h2 class="PartnerAdvantagestyles__WhyPartnerHeadText-sc-4j37pk-3 eJkCcT">myPartner Advantages</h2>
    <p class="PartnerAdvantagestyles__WhyPartnerSubText-sc-4j37pk-4 dgrPZV">It is a feature loaded platform!</p> */}
     <div className="main_title_2">
          <h3>Our Advantages</h3><br/>
          <span><em></em></span>
        </div>
    </div>
    {/* <div class="PartnerAdvantagestyles__ImageBackOval-sc-4j37pk-5 bBtKOD">
    </div> */}
    <div class="PartnerAdvantagestyles__PartnerAdvantageWrap-sc-4j37pk-6 gCqNAw">
    <div class="PartnerAdvantagestyles__AdvantageTileWrap-sc-4j37pk-7 cGFczp">
    <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS">
    <div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
    <img src="images/agent-home/our-advantage/1-noun-itinerary-3327523.png" alt="" className="home-our-advantage"/>
    
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
    <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">Now you have the ability to build you guest’s itinerary while they are sitting in front of you. With instant availability, pricing, promotional offers for all services including: accommodations, ferry, transfers, events and things to do.</p>
    </div>
    </div>
    <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS">
    <div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
    <img src="images/agent-home/our-advantage/2-noun-center-186730.png" alt="" className="home-our-advantage"/></div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo"><p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">Ease of use with everything in one place with instant availability, rates, minimum nights and promos. The complete inventory at your finger tip for instant confirmed booking.</p>
    </div>
    </div>
    
    <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS">
    <div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
   
    <img src="images/agent-home/our-advantage/3-noun-shopping-cart-5026701.png" alt="" className="home-our-advantage"/>
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
    <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">
    You will be able to add items to a shopping card to build an itinerary.  Get the itinerary in a PDF format to share with travelling partners.</p>
    </div></div>
    <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS">
    <div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
    <img src="images/agent-home/our-advantage/4-noun-reduce-613181.png" alt="" className="home-our-advantage"/>
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
    <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">No need to sign yearly contract with the hotels. Therefore, reduce the burden and cost involved in this yearly process.</p></div>
    </div>
    <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS">
    <div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
    <img src="images/agent-home/our-advantage/5-noun-reservation-pending-1500055.png" alt="" className="home-our-advantage"/>
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
    <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">Flexible booking process. Build up your client itinerary. Edit and manage this itinerary, confirm the booking. Print in a beautiful PDF file and present to your client. After client review, you can edit accordingly and finalize the booking.</p></div>
    </div>
    <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS"><div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
    <img src="images/agent-home/our-advantage/6-noun-island-4538449.png" alt="" className="home-our-advantage"/>
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
      <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">Have access to multiple islands.</p>
      </div>
      </div>

      <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS"><div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
      <img src="images/agent-home/our-advantage/7-noun-competitive-5016936.png" alt="" className="home-our-advantage"/>
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
      <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">Very competitive rates when compared to online Travel Agents.</p>
      </div>
      </div>


      <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS"><div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
      <img src="images/agent-home/our-advantage/8-noun-activity-5013567.png" alt="" className="home-our-advantage"/>
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
      <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">You will have access to events and activities that the online Travel Agents do not have giving you a major advantage when dealing with clients.</p>
      </div>
      </div>

      <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS"><div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
      <img src="images/agent-home/our-advantage/9-noun-commission-2070169.png" alt="" className="home-our-advantage"/>
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
      <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">We will do all the ground work of getting supplier contract and apply a shared commission process.</p>
      </div>
      </div>
      <div class="PartnerAdvantagestyles__AdvantageTile-sc-4j37pk-8 egkUwS"><div class="PartnerAdvantagestyles__TileIconWrap-sc-4j37pk-9 kZphlZ">
      <img src="images/agent-home/our-advantage/10-noun-report-5026801.png" alt="" className="home-our-advantage"/>
    
    </div>
    <div class="PartnerAdvantagestyles__TileTextWrap-sc-4j37pk-10 bAlWvo">
      <p class="PartnerAdvantagestyles__TileText-sc-4j37pk-11 dZlQUC">Reporting system to help reconcile the management of your reservations and financials satiations.</p>
      </div>
      </div>



      </div>
     
        </div>
        </div>
        </div>


    <div className="bg_color_1" style={{backgroundColor:'#f1f1f1', paddingTop: '10px'}}>
      <div className="container">
        <div className="main_title_2">
          <h3>And More…  </h3><br/>
          <span><em></em></span>
        </div>
        <div className="row" style={{paddingTop: '15px'}}>
          <div className="col-lg-6">
            <div className="box_news" href="#0">
              <figure style={{borderRadius: '50%',backgroundColor: 'white'}}>
              <img src="https://supplier.holidays-seychelles.com/public/images/join-seychelles-images/background-images/001.png" alt="" style={{width:'80px'}}/>
              </figure>
              {/* <h4>Talk to us</h4> */}
              <p>The client voucher will have your own logo and brand material at the top. Keeping your contact with the visitors.</p>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="box_news" href="#0">
            <figure style={{borderRadius: '50%',backgroundColor: 'white'}}>
            <img src="https://supplier.holidays-seychelles.com/public/images/join-seychelles-images/background-images/001.png" alt="" style={{width:'80px'}}/>
              </figure>
              {/* <h4>Tip to Success</h4> */}
              <p>The client voucher will have all the booked items with correct pricing.</p>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="box_news" href="#0">
              <figure style={{borderRadius: '50%',backgroundColor: 'white'}}>
              <img src="https://supplier.holidays-seychelles.com/public/images/join-seychelles-images/background-images/001.png" alt="" style={{width:'80px'}}/>
              </figure>
              {/* <h4>Talk to us</h4> */}
              <p>Each supplier would have received their respective booking in their own working space and ready to receive your clients.</p>
            </div>
          </div>
          
          <div className="col-lg-6">
            <div className="box_news" href="#0">
            <figure style={{borderRadius: '50%',backgroundColor: 'white'}}>
            <img src="https://supplier.holidays-seychelles.com/public/images/join-seychelles-images/background-images/001.png" alt="" style={{width:'80px'}}/>
              </figure>
              {/* <h4>Tip to Success</h4> */}
              <p>You will be able to grade and provide feedback on the supplier so that we can keep improving.</p>
            </div>
          </div>
        </div>
      </div>
    
    </div>

    </>
   
  );
};

export default AgentContent;
